<template>
  <div id="home">
    <TheContent :floors="jsonData.floors"/>
    <TheHeader />
    <TheNavBar />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TheHeader from '../components/TheHeader.vue';
import TheContent from '../components/TheContent.vue';
import TheNavBar from '../components/TheNavBar.vue';

export default {
  name: 'Home',
  components: {
    TheHeader,
    TheContent,
    TheNavBar,
  },
  computed: {
    ...mapGetters(['jsonData']),
  },
  methods: {
    ...mapActions(['setFloorIndex']),
  },
  mounted() {
    // this.setFloorIndex(0);
  },
};
</script>

<style lang="scss">
#home {
  width: 100vw;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
}
</style>
